<a
  uiSref="deploys-show"
  [uiParams]="{ projectId: activity.projectId, deployId: activity.trackableId }"
>
  Deployed
</a>
<span *ngIf="activity.environment">
  to
  <ab-env-label [env]="activity.environment"></ab-env-label>
</span>
<span *ngIf="!activity.environment || !activity.userName">
  (see how to get more from
  <ab-external-link
    href="https://docs.airbrake.io/docs/features/deploy-tracking/"
    >deploy tracking</ab-external-link
  >)
</span>
<span
  *ngIf="
    activity.subActivities && activity.subActivities['group.resolved'].length
  "
>
  (resolving
  <button class="btn btn--link btn--no-shadow" (click)="toggleShowNested()">
    {{ activity.subActivities["group.resolved"].length }}
    {{
      activity.subActivities["group.resolved"].length === 1 ? "error" : "errors"
    }}</button
  >)
</span>
<ul class="list-inline list-unstyled" *ngIf="showNested">
  <li
    class="list-inline-item comma-list-item"
    *ngFor="
      let subActivity of visibleSubActivities['group.resolved'];
      index as $index;
      trackBy: trackByTrackableId
    "
  >
    <ab-group-activity
      [activity]="subActivity"
      [nested]="true"
      [index]="$index"
    ></ab-group-activity>
  </li>
</ul>
